import { skipToken } from '@reduxjs/toolkit/dist/query';
import theme from 'common/theme/theme';
import { useGetDomainGraphQuery } from 'features/api';
import GraphPopover from 'features/forceGraphs/components/common/GraphPopover';
import {
	StyledGraphContainer,
	StyledHeading,
} from 'features/forceGraphs/components/common/styledComponents';
import { drawNode, drawLink } from 'features/forceGraphs/helpers';
import useGraphDataLoader from 'features/forceGraphs/hooks/useGraphDataLoader';
import useGraphHandlers from 'features/forceGraphs/hooks/useGraphHandlers';
import GraphContextProvider from 'features/forceGraphs/state/GraphContextProvider';
import useActiveDomainData from 'features/ontology/hooks/useActiveDomainData';
import { FunctionComponent } from 'react';
import { default as ForceGraph2D } from 'react-force-graph-2d';

const DomainGraphBody: FunctionComponent = () => {
	const { activeItem } = useActiveDomainData();

	const queryRes = useGetDomainGraphQuery(
		activeItem ? { domainId: activeItem._id } : skipToken
	);

	useGraphDataLoader(queryRes);

	const { selectNode, width, height, setFgm, graphState } =
		useGraphHandlers();

	return (
		<StyledGraphContainer>
			<div>
				{graphState.isLoadingData && (
					<StyledHeading component="h2">
						Preparing your data...
					</StyledHeading>
				)}
				<ForceGraph2D
					ref={setFgm as any}
					backgroundColor={theme.palette.background.default}
					width={width}
					height={height}
					graphData={graphState.graphData}
					onNodeClick={selectNode as any}
					linkCanvasObject={drawLink}
					// linkLabel={(link: any) => link.plural}
					nodeId="_id"
					nodeLabel={() => ''}
					linkCanvasObjectMode={() => 'replace'}
					nodeCanvasObject={drawNode()}
				/>
			</div>
			<GraphPopover />
		</StyledGraphContainer>
	);
};

const AccountGraph: FunctionComponent = () => {
	return (
		<GraphContextProvider>
			<DomainGraphBody />
		</GraphContextProvider>
	);
};

export default AccountGraph;
